import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {wrapActionCreator} from '../../../../../libs/shared/core/src/store/helpers/reduxHelpers';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useAppDispatch} from '../../../../helpers/appReduxHelpers';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {TopBarButton} from '../topBarButton';
import {IncidentsDropdown} from './incidentsDropdown';
import {useFetchIncidentsPeriodically} from './incidentsHooks';

/*
 * Component.
 */

export const Incidents: FC = () => {
  const theme = useUserTheme();

  const dispatch = useAppDispatch();
  const onOpenUrlClick = wrapActionCreator(dispatch, navigateToLinkAction);

  const incidents = useFetchIncidentsPeriodically();
  if (incidents.length === 0) {
    return null;
  }

  const renderIncidentsButton = (isDropdownOpen: boolean) => (
    <TopBarButton
      iconName="warningFilledTriangle"
      iconColor={theme.palette.orange.shade40}
      isSelected={isDropdownOpen}
      renderTooltip={() => <Trans id="incidents-button">Incidents</Trans>}
    >
      <Trans id="incidents-button">Incidents</Trans>
    </TopBarButton>
  );

  const renderIncidentsDropdown = (popoverProps: PopoverTransferProps) => (
    <IncidentsDropdown popoverProps={popoverProps} incidents={incidents} onOpenUrlClick={onOpenUrlClick} />
  );

  return (
    <PopoverCoordinator
      renderButton={(isOpen) => renderIncidentsButton(isOpen)}
      renderModal={(popoverProps) => renderIncidentsDropdown(popoverProps)}
    />
  );
};
